<script setup>
import moment from "moment";
</script>
<template>
  <DefaultLayout>
    <v-row class="mx-5 mt-5">
      <v-col cols="12">
        <div
          class="bg-red-ss rounded-top-10 w-100 border border-1 pt-2"
          style="min-height: 5vh"
        >
          <div style="color: #28293d" class="flex items-center mb-2">
            <button @click="$router.back()" class="btn">
              <font-awesome-icon
                icon="fa-solid fa-arrow-left"
                style="color: #28293d"
              />
            </button>
            Dokumen Pra-Presentasi PJP Baru
          </div>
          <div
            class="bg-white rounded-top-10 w-100 border border-1 shadow-sm p-2"
            style="min-height: 60vh"
          >
            <div class="row">
              <div
                class="col-md-6 d-flex justify-content-start"
                style="padding-left: 2rem; padding-top: 0.5rem"
              >
                <img
                  src="../../assets/images/borneo-indobara-icon.png"
                  alt=""
                  style="width: 15%; height: auto"
                />
              </div>
              <div
                class="col-md-6 d-flex justify-content-end"
                style="padding-right: 2rem; padding-top: 0.5rem"
              >
                <p class="fs-5 fw-bold" style="">BIB-HSE-PPO-F-096-03</p>
              </div>
            </div>
            <div class="container p-4">
              <h1 class="text-center mb-3 font-inter font-bold text-3xl">
                SURAT PERNYATAAN<br />
                DUKUNGAN PIMPINAN PERUSAHAAN
              </h1>
              <p
                class="text-center fs-8 mb-3"
                style="font-family: 'Inter-Regular'"
              >
                Formulir ini untuk memberi dukungan resmi manajemen pada
                penunjukan PJO perusahaan jasa/ mitra kerja di PT Borneo
                Indobara
              </p>
              <!-- form di sini -->
              <form action="#" @submit.prevent="preventSubmit">
                <div class="row mb-2">
                  <div class="col-md-3">&nbsp;</div>
                  <div class="col-md-6">
                    <p for="nomor" class="form-label text-center fs-8 fw-bold">
                      Nomor <span class="text-danger fs-6">*</span>
                    </p>
                    <input
                      type="text"
                      class="form-control fs-9"
                      id="nomor"
                      placeholder="Masukkan Nomor Anda"
                      v-model="formValues.nomor"
                      :disabled="statusSio != 0 && statusSio != -3"
                    />
                  </div>
                  <div class="col-md-3">&nbsp;</div>
                </div>
                <p class="mb-2 fs-8">Saya yang bertanda tangan di bawah ini:</p>
                <div class="row mb-2">
                  <div class="col-md-6">
                    <label for="nama" class="form-label fs-8 fw-bold"
                      >Nama <span class="text-danger fs-6">*</span></label
                    >
                    <input
                      type="text"
                      class="form-control fs-9"
                      id="nama"
                      placeholder="Masukkan Nama Lengkap Pimpinan Tertinggi Perusahaan"
                      v-model="formValues.nama"
                      :disabled="
                        (statusSio != 0 && statusSio != -3) ||
                        formValues.nama != null
                      "
                    />
                  </div>
                  <div class="col-md-6">
                    <label for="perusahaan" class="form-label fs-8 fw-bold"
                      >Perusahaan</label
                    >
                    <input
                      type="text"
                      class="form-control fs-9"
                      id="perusahaan"
                      placeholder="Masukkan PT/CV"
                      v-model="formValues.perusahaan"
                      disabled
                    />
                  </div>
                </div>
                <div class="row mb-3">
                  <div class="col-md-6">
                    <label for="jabatan" class="form-label fs-8 fw-bold"
                      >Jabatan <span class="text-danger fs-6">*</span></label
                    >
                    <input
                      type="text"
                      class="form-control fs-9"
                      id="jabatan"
                      placeholder="Masukkan Nama Jabatan Pimpinan Tertinggi Perusahaan"
                      v-model="formValues.jabatanPimpinan"
                      :disabled="
                        (statusSio != 0 && statusSio != -3) ||
                        formValues.jabatanPimpinan != null
                      "
                    />
                  </div>
                </div>
                <p class="mb-1 fs-8" style="font-family: 'Inter-Regular'">
                  Menyatakan dukungan penuh kepada:
                </p>
                <div class="row mb-2">
                  <div class="col-md-6">
                    <label for="nama" class="form-label fs-8 fw-bold"
                      >Nama <span class="text-danger fs-6">*</span></label
                    >
                    <input
                      type="text"
                      class="form-control fs-9"
                      id="nama"
                      placeholder="Masukkan Nama Calon PJO"
                      v-model="formValues.namaPjo"
                      :disabled="
                        (statusSio != 0 && statusSio != -3) ||
                        formValues.namaPjo != null
                      "
                    />
                  </div>
                  <div class="col-md-6">
                    <label for="jabatan" class="form-label fs-8 fw-bold"
                      >Jabatan <span class="text-danger fs-6">*</span></label
                    >
                    <input
                      type="text"
                      class="form-control fs-9"
                      id="jabatan"
                      placeholder="Jabatan Struktural Calon PJO"
                      v-model="formValues.jabatan"
                      :disabled="
                        (statusSio != 0 && statusSio != -3) ||
                        formValues.jabatan != null
                      "
                    />
                  </div>
                </div>
                <p class="mb-3 fs-8" style="font-family: 'Inter-Regular'">
                  Untuk menjalankan program kegiatan sebagai Penanggung Jawab
                  Operasional (PJO) di
                </p>
                <div class="row mb-2">
                  <div class="col-md-6">
                    <label for="nama" class="form-label fs-8 fw-bold"
                      >Perusahaan</label
                    >
                    <input
                      type="text"
                      class="form-control fs-9"
                      id="nama"
                      placeholder="Masukkan PT/CV"
                      v-model="formValues.perusahaan"
                      disabled
                    />
                  </div>
                </div>
                <p class="mb-3 fs-8" style="font-family: 'Inter-Regular'">
                  sesuai dengan peraturan dan ketentuan yang berlaku.
                </p>
                <p class="mb-3 fs-8" style="font-family: 'Inter-Regular'">
                  Dan Penanggung Jawab Operasional (PJO) mempunyai wewenang
                  penuh dalam pengelolaan Keselamatan Pertambangan dan
                  Lingkungan Hidup (KPLH) sesuai Kebijakan PT Borneo Indobara,
                  termasuk sumber daya manusia maupun biaya yang dibutuhkan.<br /><br />
                  Demikian Surat Pernyataan ini untuk digunakan sebagaimana
                  mestinya.
                </p>
                <div class="row mb-3">
                  <div class="col-md-3">
                    <label for="tempat" class="form-label fs-8 fw-bold"
                      >Tempat <span class="text-danger fs-6">*</span></label
                    >
                    <input
                      type="text"
                      class="form-control fs-9"
                      id="tempat"
                      placeholder="Masukkan Tempat"
                      v-model="formValues.tempat"
                      :disabled="statusSio != 0 && statusSio != -3"
                    />
                  </div>
                  <div class="col-md-3">
                    <label for="tanggal" class="form-label fs-8 fw-bold"
                      >Tanggal <span class="text-danger fs-6">*</span></label
                    >
                    <datepicker
                      v-model="formValues.tanggal"
                      value=""
                      name="tanggal"
                      placeholder="Pilih Tanggal"
                      class="form-control fs-9"
                      input-class="fw-bold"
                      format="yyyy-MM-dd"
                      :disabled="statusSio != 0 && statusSio != -3"
                    ></datepicker>
                  </div>
                </div>

                <p class="mb-3 fs-8" style="font-family: 'Inter-Regular'">
                  Yang Membuat Pernyataan,
                </p>

                <div class="row mb-2">
                  <div class="col-md-6">
                    <label for="tandaTangan" class="form-label fs-8 fw-bold">
                      Tanda Tangan (png, jpg, jpeg)
                      <span class="text-danger fs-6">*</span>
                    </label>
                    <div v-if="fileTtd != ''" class="fs-8">
                      <img :src="fileTtd" style="height: 5rem" />
                    </div>
                    <!-- <Vue3Signature  ref="signature1" :sigOption="state.option" :w="'100%'" :h="'85%'"
                            :disabled="state.disabled" class="example border"></Vue3Signature> -->
                    <div
                      class="input-group mb-1"
                      :hidden="
                        (statusSio != 0 && statusSio != -3) || fileTtd != ''
                      "
                    >
                      <input
                        type="file"
                        ref="tandaTangan"
                        accept="image/png, image/jpg, image/jpeg"
                        class="form-control fs-9"
                        id="inputGroupFile04"
                        @change="handleChangeFile('tandaTangan')"
                        aria-describedby="inputGroupFileAddon04"
                        aria-label="Upload"
                      />
                      <button
                        class="btn btn-outline-secondary fs-9 border border-start-0"
                        type="button"
                        id="inputGroupFileAddon04"
                      >
                        <font-awesome-icon
                          icon="fa-solid fa-cloud-arrow-up"
                          style="color: #000000"
                        />
                      </button>
                    </div>
                    <div
                      v-if="validasiFile.sizeTtd"
                      class="fs-8 text-danger fst-italic"
                    >
                      Ukuran file melebihi batas (Max: {{ max_file_size }}MB)
                    </div>
                    <div
                      v-if="validasiFile.typeTtd"
                      class="fs-8 text-danger fst-italic"
                    >
                      Ekstensi file tidak sesuai, Mohon tambahkan file Gambar
                      png, jpg, jpeg
                    </div>
                  </div>
                </div>

                <div class="row mb-lg-2">
                  <div class="col-md-6">
                    <label for="namaPimpinan" class="form-label fs-8 fw-bold"
                      >Nama Lengkap
                      <span class="text-danger fs-6">*</span></label
                    >
                    <input
                      type="text"
                      class="form-control fs-9"
                      id="namaPimpinan"
                      placeholder="Masukkan Nama Lengkap"
                      v-model="formValues.namaTTD"
                      :disabled="
                        (statusSio != 0 && statusSio != -3) ||
                        formValues.namaTTD != null
                      "
                    />
                    <label class="form-label fs-8 fw-bold"
                      >Pimpinan Tertinggi Perusahaan</label
                    >
                  </div>
                </div>
                <p class="mb-3 fs-8" style="font-family: 'Inter-Regular'">
                  Catatan:<br />
                  Apabila terjadi perubahan terhadap pimpinan tertinggi dalam
                  struktur organisasi, maka pimpinan tertinggi dalam organisasi
                  wajib menyampaikan Surat Dukungan ulang paling lama 7 hari
                  setelah ada pergantian.<br />
                  Pimpinan tertinggi yang baru wajib menyampaikan komitmennya
                  kepada PT Borneo Indobara dalam bentuk presentasi.
                </p>

                <div class="row mt-3">
                  <div class="col-md-6">
                    <p class="text-danger fst-italic fs-8 fw-bold mb-1">
                      * Wajib diisi
                    </p>
                    <p></p>
                  </div>

                  <div
                    class="col-md-6 d-flex justify-content-end align-items-end"
                  >
                    <button
                      type="button"
                      @click="clickSimpan()"
                      class="btn btn_cari w-50"
                      style="height: 2.5rem"
                      :hidden="statusSio != 0 && statusSio != -3"
                      :disabled="disabled"
                    >
                      {{
                        statusSio == 0
                          ? "Submit"
                          : statusSio == -3
                          ? "Submit Ulang"
                          : "Submit"
                      }}
                    </button>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </v-col>
    </v-row>
  </DefaultLayout>
  <!-- Loading overlay -->
  <div v-if="isLoading" class="loading-overlay">
    <!-- You can customize the loading content here (e.g., a spinner) -->
    <div>
      <img
        src="../../assets/icons/Spinner-1s-200px.svg"
        style="height: 10rem"
        alt=""
      />
    </div>
  </div>
</template>
<style>
section .vuejs3-datepicker__calendar-topbar {
  min-height: auto;
}

.vuejs3-datepicker__value {
  font-size: 0.7rem !important;
  border: 0px !important;
  padding: 0px !important;
}
.vuejs3-datepicker__icon svg {
  height: 0.8rem;
}

.vuejs3-datepicker__content {
  font-size: 0.8rem !important;
  margin-left: 0.3rem !important;
  margin-bottom: -1rem !important;
}
.loading-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(255, 255, 255, 0.8); /* Semi-transparent white overlay */
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000; /* Make sure it's above other elements on the page */
}

.loading-spinner {
  /* Add your loading spinner styles here */
  border: 4px solid #f3f3f3;
  border-top: 4px solid #3498db;
  border-radius: 50%;
  width: 40px;
  height: 40px;
  /* animation: spin 1s linear infinite; */
}

/* @keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
} */
</style>

<script>
// import router from "../router";
// import SidebarComponent from "@/components/SideBar.vue"
import GlobalDataMixin from "../../GlobalDataMixin";
import Datepicker from "vuejs3-datepicker";

import axios from "axios";
import Swal from "sweetalert2";

import {
  API_BASE_URL,
  CMS_DOWNLOAD,
  CMS_UPLOAD_USECASE,
  CMS_VIEW_IMAGE,
  CMS_SIO_SET_DUKUNGAN_PIMPINAN,
  CMS_SIO_GET_DUKUNGAN_PIMPINAN,
  CMS_GET_KELENGKAPAN_SIO,
  CMS_SIO_GET_DASHBOARD,
  CMS_GET_SIOID,
} from "../../constants.js";

const url_simpan = API_BASE_URL + CMS_SIO_SET_DUKUNGAN_PIMPINAN;
const url_upload_usecase = API_BASE_URL + CMS_UPLOAD_USECASE;
const url_get_dukungan = API_BASE_URL + CMS_SIO_GET_DUKUNGAN_PIMPINAN;
const url_get_siodashboard = API_BASE_URL + CMS_SIO_GET_DASHBOARD;
const url_get_sioid = API_BASE_URL + CMS_GET_SIOID;
const url_get_kelengkapan = API_BASE_URL + CMS_GET_KELENGKAPAN_SIO;

const url_download = API_BASE_URL + CMS_DOWNLOAD;
const max_file_size = 5; // MB

import { reactive, ref } from "vue";
import DefaultLayout from "@/layouts/DefaultLayout.vue";

const state = reactive({
  count: 0,
  option: {
    penColor: "rgb(0, 0, 0)",
    backgroundColor: "rgb(255,255,255)",
  },
  disabled: false,
});

const signature1 = ref(null);

export default {
  mixins: [GlobalDataMixin],
  name: "FormSuratPermohonanPengesahanPJO",
  components: { DefaultLayout, Datepicker },
  data() {
    return {
      sioID: null,
      idKelengkapan: null,
      isLoading: false,
      refIDForm: 5,
      idForm: null,
      formValues: {
        nomor: "",
        nama: "",
        jabatanPimpinan: "",
        namaPjo: "",
        jabatan: "",
        tempat: "",
        tanggal: moment(new Date()).format("YYYY-MM-DD"),
        tandaTangan: "",
        namaTTD: "",
      },
      url_icon: "",
      fileTtd: "",
      // fileAttachment: '',
      validasiFile: {
        typeTtd: false,
        sizeTtd: false,
        typeAtt: false,
        sizeAtt: false,
      },
      kontraktorID: null,
      statusSio: 0,
      disabled: false
    };
  },
  mounted() {
    this.kontraktorID = parseInt(this.userData.kontraktorID);
    if (localStorage.getItem("sio_cms") != null) {
      this.sioID = JSON.parse(localStorage.getItem("sio_cms")).id;
      this.getSioDashboard(this.sioID);
      this.getSioID(this.kontraktorID);
      this.getKelengkapan(this.sioID);
    }

    if (localStorage.getItem("icon_kontraktor_cms") != null) {
      this.url_icon =
        API_BASE_URL +
        CMS_VIEW_IMAGE +
        JSON.parse(localStorage.getItem("icon_kontraktor_cms")).icon;
    }
    this.formValues.perusahaan =
      this.userData.kontraktorName != null
        ? this.userData.kontraktorName
        : null;
  },
  methods: {
    preventSubmit() {
      console.log("prevent submit");
    },
    getSioDashboard(sio_id) {
      axios
        .get(url_get_siodashboard + sio_id, {
          headers: {
            role: this.userData.role,
            Authorization: "Bearer " + this.userData.token,
            accept: "*/*",
          },
        })
        .then((response) => {
          console.log(response);
          let ret_dash = response.data.data;
          if (ret_dash.length > 0) {
            for (let i = 0; i < ret_dash.length; i++) {
              if (ret_dash[i].idForm == this.refIDForm) {
                this.idForm = ret_dash[i].id;
                this.getDukungan(ret_dash[i].id);
              }
            }
          }
          // this.isLoading = false;
        })
        .catch((error) => {
          this.isLoading = false;
          alert("Error Fetch Data getSioDashboard : " + error.message);
          console.error("Error fetching data getSioDashboard :", error.message);
        });
    },
    getDukungan(idform) {
      axios
        .get(url_get_dukungan + idform, {
          headers: {
            role: this.userData.role,
            Authorization: "Bearer " + this.userData.token,
            accept: "*/*",
          },
        })
        .then((response) => {
          console.log("getPJOPengesahan", response);
          let dt = response.data.data;

          if (dt != null) {
            this.formValues.nomor = dt.nomorSurat == null ? "" : dt.nomorSurat;
            // this.formValues.nama = dt.namaPimpinan==null?'':dt.namaPimpinan;
            // this.formValues.jabatanPimpinan = dt.jabatanPimpinan==null?'':dt.jabatanPimpinan;
            // this.formValues.namaPjo = dt.namaPjo==null?'':dt.namaPjo;
            // this.formValues.jabatan = dt.jabatanPjo==null?'':dt.jabatanPjo;
            this.formValues.tempat = dt.tempat == null ? "" : dt.tempat;
            this.formValues.tanggal =
              dt.tanggalTtd != null
                ? moment(dt.tanggalTtd).format("YYYY-MM-DD")
                : null;
            // if(dt.tandaTangan!=''&&dt.tandaTangan!=null) {
            //   this.fileTtd = API_BASE_URL + CMS_VIEW_IMAGE + dt.tandaTangan;
            // }
            // if(dt.attachmentFile!=''&&dt.attachmentFile!=null){
            //   this.fileAttachment = dt.attachmentFile;
            // }
            // this.formValues.namaTTD = dt.namaPengesah==null?'':dt.namaPengesah;
          }
          this.isLoading = false;
        })
        .catch((error) => {
          this.isLoading = false;
          alert("Error Fetch Data getSioDashboard : " + error.message);
          console.error("Error fetching data getSioDashboard :", error.message);
        });
    },

    async simpanDukungan() {
      this.disabled = true
      const tandaTangan = this.$refs.tandaTangan.files[0];
      // const fileAttachment = this.$refs.fileAttachment.files[0];
      var purs = [];
      var files = [];
      console.log("file ttd = ", tandaTangan);
      if (tandaTangan != null) {
        purs.push("form5");
        files.push(tandaTangan);
      }
      // if(fileAttachment!=null){
      //   purs.push('attachment');
      //   files.push(fileAttachment);
      // }
      let bodyJsonProfile = {};
      if (this.idForm != null) {
        bodyJsonProfile = {
          id: this.idForm,
          idSio: this.sioID,
          // "kontraktorId": this.userData.kontraktorID,
          nomorSurat: this.formValues.nomor,
          namaPimpinan: this.formValues.nama,
          jabatanPimpinan: this.formValues.jabatanPimpinan,
          namaPjo: this.formValues.namaPjo,
          jabatanPjo: this.formValues.jabatan,
          tanggalTtd:
            this.formValues.tanggal != null && this.formValues.tanggal != ""
              ? moment(this.formValues.tanggal).format("YYYY-MM-DD")
              : null,
          tempat: this.formValues.tempat,
          namaPengesah: this.formValues.namaTTD,
          // "reason":'',
        };
      } else {
        bodyJsonProfile = {
          // "id": 0,
          idSio: this.sioID,
          // "kontraktorId": this.userData.kontraktorID,
          nomorSurat: this.formValues.nomor,
          namaPimpinan: this.formValues.nama,
          jabatanPimpinan: this.formValues.jabatanPimpinan,
          namaPjo: this.formValues.namaPjo,
          jabatanPjo: this.formValues.jabatan,
          tanggalTtd:
            this.formValues.tanggal != null && this.formValues.tanggal != ""
              ? moment(this.formValues.tanggal).format("YYYY-MM-DD")
              : null,
          tempat: this.formValues.tempat,
          namaPengesah: this.formValues.namaTTD,
          reason: "",
        };
      }
      await axios
        .post(url_simpan, bodyJsonProfile, {
          headers: {
            role: this.userData.role,
            Authorization: "Bearer " + this.userData.token,
            accept: "*/*",
          },
        })
        .then((response) => {
          console.log("response simpanDukungan : ", response);
          let idForm = response.data.data.id;

          if (files.length > 0 && purs.length > 0) {
            this.uploadFiles(files, purs, idForm);
          } else {
            this.alertSukses();
          }
        })
        .catch((error) => {
          console.log("error simpanDukungan : ", error);
          alert("error simpan Dokumen Dukungan Pimpinan");
          // if(error.response.status==500){
          //     alert("Error "+error.response.status+" simpanAddSubKontraktor : " + error.response.data.status.message)
          // }else if(error.response.status==400){
          //     alert("Error "+error.response.status+" simpanAddSubKontraktor : " + error.response.data.status.message)
          // }else if(error.response.status==401){
          //     alert("Error "+error.response.status+" simpanAddSubKontraktor : " + error.response.data.status.message)
          // }
        })
        .then(() => {});
    },
    async uploadFiles(files, purs, idForm) {
      for (var x in files) {
        // console.log(files[x])
        // console.log(purs[x])
        let file = files[x];
        let pur = purs[x];
        if (file) {
          // Get the file name
          const fileName = file.name;

          // Create a FormData object and append the file
          const formData = new FormData();
          formData.append("file", file);
          formData.append("id", idForm);
          formData.append("purpose", pur);
          formData.append("usecase", "ttd_form5");
          // Make the API request to upload the file
          try {
            const response = await axios.post(url_upload_usecase, formData, {
              headers: {
                "Content-Type": "multipart/form-data",
                role: this.userData.role,
                Authorization: "Bearer " + this.userData.token,
                accept: "*/*",
              },
            });

            // Handle the response from the server as needed
            console.log("File upload response:", response.data);
            console.log("filename : ", fileName);
          } catch (error) {
            // Handle errors, e.g., display an error message to the user
            alert(error.message);
            if (error.response.data != null) {
              alert(error.response.data.message);
            }
            this.isLoading = false;
            console.error("Error uploading file:", error);
            // this.$router.go(this.$router.currentRoute)
          }
        }
      }
      this.alertSukses();
    },
    clickSimpan() {
      this.isLoading = true;
      if (this.validasiForm()) {
        this.simpanDukungan();
      } else {
        alert("Lengkapi pengisian form !");
        this.isLoading = false;
      }
    },
    validasiForm() {
      if (
        this.formValues.nomor.trim() != "" &&
        this.formValues.nama.trim() != "" &&
        this.formValues.jabatanPimpinan.trim() != "" &&
        this.formValues.jabatan.trim() != "" &&
        this.formValues.namaPjo.trim() != "" &&
        this.formValues.tempat.trim() != "" &&
        this.formValues.tanggal != "" &&
        this.formValues.namaTTD != "" &&
        (this.fileTtd != "" || this.$refs.tandaTangan.value != "")
        // &&(this.fileAttachment!=""||this.$refs.fileAttachment.value!="")
      ) {
        return true;
      } else {
        return false;
      }
    },
    save(t) {
      console.log(signature1.value.save(t));
      console.log(signature1);
      console.log(signature1.value);
      state.disabled = true;
    },

    clear() {
      signature1.value.clear();
      state.disabled = false;
    },

    undo() {
      signature1.value.undo();
      state.disabled = false;
    },

    alertSukses() {
      Swal.fire({
        title: "Simpan Form Sukses",
        text: "Surat Pernyataan Dukungan Pimpinan Perusahaan Berhasil disimpan !",
        icon: "success",
        showConfirmButton: false,
        timer: 2000,
        showClass: {
          popup: "animate__animated animate__fadeInDown",
        },
        hideClass: {
          popup: "animate__animated animate__fadeOutUp",
        },
      }).then(() => {
        this.$router.back();
      });
    },
    handleChangeFile(refFile) {
      let file = null;

      if (refFile == "tandaTangan") {
        file = this.$refs.tandaTangan.files[0];
        if (file) {
          // Check file type
          if (
            file.type !== "image/jpg" &&
            file.type !== "image/jpeg" &&
            file.type !== "image/png"
          ) {
            this.validasiFile.typeTtd = true;
            this.validasiFile.sizeTtd = false;
            this.$refs.tandaTangan.value = "";
            return;
          }

          // Check file size ({{max_file_size}}MB limit)
          if (file.size > max_file_size * 1024 * 1024) {
            this.validasiFile.typeTtd = false;
            this.validasiFile.sizeTtd = true;
            this.$refs.tandaTangan.value = "";
            return;
          }

          // Reset error messages if the file is valid
          this.validasiFile.typeTtd = false;
          this.validasiFile.sizeTtd = false;

          // Handle the valid file as needed (e.g., store the file)
          console.log("Valid file:", file);
        }
      }
      // else if(refFile=='fileAttachment'){
      //   file = this.$refs.fileAttachment.files[0];
      //   if (file) {
      //     // Check file type
      //     if (file.type !== "application/pdf") {
      //       this.validasiFile.typeAtt = true
      //       this.validasiFile.sizeAtt = false
      //       this.$refs.fileAttachment.value = ""
      //       return
      //     }

      //     // Check file size ({{max_file_size}}MB limit)
      //     if (file.size > max_file_size * 1024 * 1024) {
      //       this.validasiFile.typeAtt = false
      //       this.validasiFile.sizeAtt = true
      //       this.$refs.fileAttachment.value = ""
      //       return
      //     }

      //     // Reset error messages if the file is valid
      //     this.validasiFile.typeAtt = false
      //     this.validasiFile.sizeAtt = false

      //     // Handle the valid file as needed (e.g., store the file)
      //     console.log('Valid file:', file);
      //   }
      // }
    },

    downloadFile(filename) {
      axios
        .get(url_download + filename, { responseType: "blob" })
        .then((response) => {
          this.handleFileDownload(response.data, filename);
        })
        .catch((error) => {
          console.error("Error downloading file:", error);
        });
    },
    handleFileDownload(blobData, filename) {
      var dateNow = moment(new Date()).format("DDMMYYYY");
      // Create a Blob from the response data
      const blob = new Blob([blobData], { type: "application/octet-stream" });
      console.log(filename);
      // Create a link element and trigger a download
      const link = document.createElement("a");
      link.href = window.URL.createObjectURL(blob);
      link.download =
        "Surat_Pernyataan_Dukungan_Pimpinan_Perusahaan_" + dateNow + ".pdf"; // Set the desired file name
      link.click();
    },
    getSioID(id) {
      axios
        .get(url_get_sioid + id, {
          headers: {
            role: this.userData.role,
            Authorization: "Bearer " + this.userData.token,
            accept: "*/*",
          },
        })
        .then((response) => {
          this.statusSio = response.data.data.status;
          this.isLoading = false;
        })
        .catch((error) => {
          this.isLoading = false;
          alert("Error Fetch Data getSioID : " + error.message);
          console.error("Error fetching data getSioID :", error.message);
        });
    },
    getKelengkapan(sio_id) {
      axios
        .get(url_get_kelengkapan + sio_id, {
          headers: {
            role: this.userData.role,
            Authorization: "Bearer " + this.userData.token,
            accept: "*/*",
          },
        })
        .then((response) => {
          console.log(response);

          let ret_kel = response.data;
          this.idKelengkapan = ret_kel.id == null ? "" : ret_kel.id;
          this.formValues.nama =
            ret_kel.namaAtasan == null ? "" : ret_kel.namaAtasan;
          this.formValues.jabatanPimpinan =
            ret_kel.jabatanAtasan == null ? "" : ret_kel.jabatanAtasan;
          this.formValues.namaPjo =
            ret_kel.namaPjo == null ? "" : ret_kel.namaPjo;
          this.formValues.jabatan =
            ret_kel.jabatanPjo == null ? "" : ret_kel.jabatanPjo;
          this.formValues.namaTTD =
            ret_kel.namaAtasan == null ? "" : ret_kel.namaAtasan;

          if (ret_kel.ttdAtasan != "" && ret_kel.ttdAtasan != null) {
            this.fileTtd = API_BASE_URL + CMS_VIEW_IMAGE + ret_kel.ttdAtasan;
          }
        })
        .catch((error) => {
          this.isLoading = false;
          alert("Error Fetch Data getKelengkapan : " + error.message);
          console.error("Error fetching data getKelengkapan :", error.message);
        });
    },
  },
};
</script>
